




import Vue from 'vue'
import subscribeBots from '@/mixins/SubscribeBots'
import { KeyDict } from '@/types'
import env from '@/env'
import { Bot } from '@/types/bots'
import './BotsMessages.scss'
import { KENV } from '@/types/admin'

export default Vue.extend({
  name: 'BotsMessages',
  mixins: [ subscribeBots ],
  computed: {
    bots (): KeyDict<Bot> {
      return this.$store.direct.state.bots.bots
    },
    messages (): string {
      let message = ''
      Object.values(this.bots).forEach(bot => {
        let latestMessage = ''
        let newestTime = 0
        for (const [time, action] of Object.entries(bot.last_actions)) {
          const actionTime = parseFloat(time)
          if (actionTime > newestTime) {
            newestTime = actionTime
            latestMessage = action.message
          }
        }
        message += `Bot ${bot.name}: ${latestMessage}<br>`
      })
      return message
    },
    visible (): boolean {
      return env !== KENV.Prod
    }
  }
})
